import { Inject, Injectable } from '@angular/core';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import {
  Environment,
  EnvironmentCompany,
  QnUrl,
} from '@cp/shared/environment/environment.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { Company } from '../shared/enums';
import { CompanyKey } from './company.config.interface';
import { companyConfig } from './company.config';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private _company: Company | null = null;
  private _companySubject: BehaviorSubject<Company | null> =
    new BehaviorSubject<Company | null>(null);

  public company$: Observable<Company | null> =
    this._companySubject.asObservable();

  constructor(@Inject(SHARED_ENVIRONMENT) private _environment: Environment) {}

  public get gtmId(): string {
    return this._environment.gtmId;
  }

  public get company(): Company {
    return this._company || this.populateCompany();
  }

  public set company(company: Company) {
    this._company = company;
    this._companySubject.next(company);
  }

  public qnUrl(version: keyof QnUrl): string {
    if (this._company === Company.tns) {
      return this._environment.tnsQnUrls[version];
    }

    return this._environment.sngQnUrls[version];
  }

  public getConfigEntry(key: CompanyKey): string {
    return companyConfig[key][this.company];
  }

  public populateCompany(): Company {
    this.company = this.getCompanyEnum(this._environment.company);
    return this.company;
  }

  public getCompanyEnum(company: EnvironmentCompany): Company {
    switch (company) {
      case 'tns':
        return Company.tns;
      case 'sng':
        return Company.sng;
      default:
        return Company.tns;
    }
  }
}
